import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const CorporateCountryFormConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/corporate-country-form",
    component: React.lazy(() => import("./corporate-country-form")),
  },
];
